import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=b9d6cbdc&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=b9d6cbdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d6cbdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9d6cbdc')) {
      api.createRecord('b9d6cbdc', component.options)
    } else {
      api.reload('b9d6cbdc', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=b9d6cbdc&scoped=true&", function () {
      api.rerender('b9d6cbdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2kcVIQZ1h51P7/JS/comp/CookieBox.vue"
export default component.exports